import { CarrierT } from "../../../../../../private/offers/domain";
import { Select } from "../select";
import { useDebounce } from "../../../hooks/use-debounce";
import { useInfiniteGetCarriers } from "../../../../../../private/offers/infrastructure/services/carrier-services";
import { CloseIcon, MagnifyingGlassIcon } from "../../../assets";
import React, { useCallback, useEffect, useState } from "react";

type FilterSelectCarriersProps = {
  movement_number: string;
  headerText: string;
  onFilter: (value: Array<string> | undefined) => void;
};

export const FilterSelectCarriers = ({
  movement_number,
  headerText,
  onFilter,
}: FilterSelectCarriersProps): React.ReactElement => {
  const [value, setValue] = useState<Array<CarrierT>>([]);
  const [name, setName] = useState<string>("");

  const nameCarrier = useDebounce(name, 800);

  const { allPages, hasNextPage, fetchNextPage, isFetching } =
    useInfiniteGetCarriers({
      s: nameCarrier !== "" ? nameCarrier : undefined,
      movement_number,
    });

  const onChange = (carriers: Array<CarrierT>): void => {
    setValue(carriers);
  };

  const getOptionLabel: (user: CarrierT) => string = useCallback(
    (user: CarrierT) => user.name,
    []
  );

  useEffect(() => {
    if (Array.isArray(value) && value.length > 0) {
      onFilter(value.map((carrier) => carrier.carrier_id));
    } else {
      onFilter(undefined);
    }
  }, [onFilter, value]);

  return (
    <section className="relative">
      <div
        className={` top-0 flex h-5 w-full  max-w-[130px] items-center justify-between rounded-[5px] bg-[#FFFFFF] py-1 pl-3 pr-1 ${
          value.length ? "shadow-[2px_2px_2px_rgba(0,0,0,0.15)]" : ""
        }`}
      >
        <Select<CarrierT>
          multiselect
          name="carriers"
          className="w-64"
          classNameContainer="w-[calc(100%-20px)]"
          value={value}
          searchValue={name}
          asyncFilter={(value) => setName(value)}
          onChange={(carriers) => {
            onChange(carriers as Array<CarrierT>);
          }}
          options={allPages}
          noMore={!hasNextPage}
          getMore={fetchNextPage}
          renderOptionComponent={getOptionLabel}
          loading={isFetching}
          labelProp="name"
          placeholder="Carrier"
          customInput={(event) => {
            return (
              <div className="w-full" onClick={event} role="presentation">
                <input
                  value={
                    value.length > 1
                      ? "Mutiple selected"
                      : value.length === 1
                      ? value[0].name
                      : ""
                  }
                  className={`w- z-[100] h-full w-full truncate p-0 text-[10px] outline-0 ${
                    value.length ? "block" : " hidden"
                  }`}
                  placeholder={headerText}
                  autoFocus
                  disabled
                />

                <div
                  className={`flex w-full flex-row items-center justify-center ${
                    value.length ? "hidden" : "visible"
                  }`}
                  role="presentation"
                >
                  <span className="mr-[10px] text-[11px]">{headerText}</span>
                  <section className="h-[14px] w-[14px] items-center justify-center">
                    <MagnifyingGlassIcon fill="#147EFB" />
                  </section>
                </div>
              </div>
            );
          }}
        />
        {value.length ? (
          <div className="flex items-center">
            <button
              onClick={() => {
                setValue([]);
              }}
            >
              <CloseIcon
                className="text-sm text-[#147EFB]"
                width={18}
                height={18}
              />
            </button>
          </div>
        ) : null}
      </div>
    </section>
  );
};
